import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import useScrollLockOnMount from "../Helpers/utils";

const ShowMoreInfo = ({post, onClose }) => {
  const [details, setDetails] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMoreInfo = async () => {
      try {
        const response = await fetch(`/php/fetch_more_info.php?uuid=${post.uuid}`);
        const data = await response.json();

        if (response.ok) {
          setDetails(data.details);
        } else {
          setError(data.message || "Something went wrong");
        }
      } catch (err) {
        setError("Error fetching data");
      } finally {
        setLoading(false);
      }
    };

    if (post && post.uuid) {
      fetchMoreInfo();
    }
  }, [post]);

  const isMobile =
    /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

    

  useScrollLockOnMount();

  return (
    <div className="more-info-modal" style={{ display: "block" }}>
      <div id="more-info" style={{ display: "block" }}>
        {/* Custom Header */}
        <header
          style={{
            backgroundColor: post.theme || "#333",
            padding: "10px",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            position: "sticky",
            top: 0,
            zIndex: 1,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                marginLeft: "20px",
                color: post.text_bg || "white",
                textAlign: "center",
                width: "100%",
              }}
            >
              Details
            </div>
            <span
              style={{
                fontSize: "33px",
                color: post.text_bg,
                cursor: "pointer",
                marginTop: isMobile ? "-5px" : "1px",
              }}
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
            >
              ×
            </span>
          </div>
        </header>
        <div
          style={{
            fontSize: "16px",
            textAlign: "center",
            color: "#333",
            margin: "7px",
            whiteSpace: new Date(post.date) < new Date('2025-09-03') ? 'pre-wrap' : 'normal',
          }}
        >
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p style={{ color: "red" }}>Error: {error}</p>
          ) : (
            // This is the key change: render the HTML content safely
            <div
              className="force-line-height"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(details || "Not Available"),
              }}
              style={{
                textAlign: "left", // Default text alignment for the rendered HTML
               
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ShowMoreInfo;